import { render, staticRenderFns } from "./UserCreate.vue?vue&type=template&id=ea514ad6"
import script from "./UserCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserCreate.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports